/**
 * 商品分组
 */
import { GOODS_GROUP } from '../types';

export default {
    name: `${GOODS_GROUP}`,
    path: '/goodsGroup',
    component: () => import(/* webpackChunkName: 'goodsGroup' */ '@/views/goodsGroup/'),
    redirect: { name: `${GOODS_GROUP}Index` },
    meta: {
        title: '商品分组',
        // 页签缓存的滚动条位置
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${GOODS_GROUP}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'goodsGroup' */ '@/views/goodsGroup/home/Home.vue'),
        },
        {
            name: `${GOODS_GROUP}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'goodsGroup' */ '@/views/goodsGroup/create/Create.vue'),
        },
        {
            name: `${GOODS_GROUP}Update`,
            path: 'update',
            component: () => import(/* webpackChunkName: 'goodsGroup' */ '@/views/goodsGroup/create/Create.vue'),
        },
    ],
};
